module.exports = __webpack_public_path__ + "static/img/thumb-04.f0c26a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/thumb/thumb-04.png
// module id = vLl3
// module chunks = 31